module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_id-42c54edb88ecf59358b4e310024e7509.jpg";